import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'roundUp',
	standalone: false,
})
export class RoundUpPipe implements PipeTransform {
	public transform(value: number = null, digit: number = 2): any {
		const val: number = +value || 0;

		return val.toFixed(digit);
	}
}
